<template>
  <router-view v-if="isLoaded"/>
</template>

<script>
  import * as userApi from '@/api/user';
  import { mapActions } from 'vuex';
  export default {
    name: 'App',
    data() {
      return {
        isLoaded: false
      }
    },
    created(){
      if(this.$browserDetect.isIE){
        if(this.$browserDetect.meta.name === "IE"){
          alert(
            'Выглядит криво? Все потому что наш сайт не поддерживает устаревшую версию IE на вашем компьютере. Пожалуйста зайдите на сайт с современного браузера, например : Microsoft Edge, Chrome, Yandex browser, Firefox и другие.'
          );
        }
      }
      userApi.me({silence401: true})
          .then(({data}) => {
            this.SET_USER(data);
          })
          .catch((err) => {
            if( ('meta' in this.$route) && this.$route.meta.guest === true ){
              console.log('guest');
            }else {
              this.$router.push({name: 'Login'});
            }
            console.log(err);
          })
          .finally(() => this.isLoaded = true);
    },
    methods:{
      ...mapActions('user', ['SET_USER']),
    }
  };
</script>

<style src="./styles/app.scss" lang="scss"/>


